import { render, staticRenderFns } from "./AboutBoccoChannel.vue?vue&type=template&id=06214618&scoped=true&"
import script from "./AboutBoccoChannel.vue?vue&type=script&lang=ts&"
export * from "./AboutBoccoChannel.vue?vue&type=script&lang=ts&"
import style0 from "./AboutBoccoChannel.vue?vue&type=style&index=0&id=06214618&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06214618",
  null
  
)

export default component.exports